var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSponsoringWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.33 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.33,0H17A16.7,16.7,0,0,0,0,17v5.67H22.67a5.34,5.34,0,0,1,5.66,5.66A5.35,5.35,0,0,1,22.67,34H0V51H17a5.36,5.36,0,0,1,5.67,5.67A5.35,5.35,0,0,1,17,62.33H0v17H22.67a5.67,5.67,0,0,1,0,11.34H0v17H17A5.67,5.67,0,1,1,17,119H0v17H22.67a5.67,5.67,0,0,1,0,11.33H0V153a16.7,16.7,0,0,0,17,17H28.33a16.69,16.69,0,0,0,17-17V17A16.69,16.69,0,0,0,28.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.33,28.33V17a16.69,16.69,0,0,0-17-17H85A16.7,16.7,0,0,0,68,17V28.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68,39.67v102a8.19,8.19,0,0,0,1.13,3.4l17,22.66a5.67,5.67,0,0,0,9.07,0l17-22.66a8,8,0,0,0,1.13-3.4v-102Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsoringWhite);
export default __webpack_public_path__ + "static/media/sponsoring_white.d4b9dda42fa47883b21a1ea2a0665ead.svg";
export { ForwardRef as ReactComponent };